import AbstractBulkClosedModel from 'uplisting-frontend/models/abstract-bulk-closed';

export default class BulkClosedForDepartureModel extends AbstractBulkClosedModel {}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'bulk-closed-for-departure': BulkClosedForDepartureModel;
  }
}
